module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Roman.0bfb049.otf";